import { Center, Loader } from '@mantine/core'

export function DefaultFallback() {
  return (
    <Center sx={{ height: '100vh' }}>
      <Loader color="gray" size="sm" />
    </Center>
  )
}
